module.exports = __webpack_public_path__ + "static/media/pen.712ba421.wav";